import Base from 'app/models/base';

import { appUrl } from 'utils/wrappers';

export default Base.extend({
  urlRoot: appUrl('email_verifications'),
  rootKey: 'email_verification',
});



// WEBPACK FOOTER //
// ./app/models/email_verification.js